import axios from 'axios'


const getData = async url => {

    const options = {
        method: 'GET',
        url,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
        }
    }

    const response = await axios(options)

    const responseOK = response && response.status === 200

    if (responseOK) {
        const data = await response.data

        return data
    } else {
        console.log("error getting menu service")
    }
}

export default {

    getPrices: async () => {

        // const url = './json/prices-pro.json';
        // const url = './json/prices-retail.json';
        const url = './json/prices-generic.json';

        return getData(url)
    }

}
